import React from 'react';
import { MAX_SAFE_DIGITS } from "../../CurrencyInput/constants";
import { CurrencyHelper } from "../../CurrencyInput/CurrencyHelper";
import { CommonWrapper } from "../../../internal/CommonWrapper";
export var defaultProps = {
  fractionDigits: 2
};
export var CurrencyLabel = function CurrencyLabel(props) {
  var value = props.value,
      fractionDigits = props.fractionDigits,
      currencySymbol = props.currencySymbol;
  return /*#__PURE__*/React.createElement(CommonWrapper, props, /*#__PURE__*/React.createElement("span", null, CurrencyHelper.format(value, {
    fractionDigits: fractionDigits
  }), currencySymbol && String.fromCharCode(0xa0)
  /* &nbsp; */
  , currencySymbol));
};
CurrencyLabel.__KONTUR_REACT_UI__ = 'CurrencyLabel';
CurrencyLabel.defaultProps = defaultProps;
CurrencyLabel.propTypes = {
  fractionDigits: function fractionDigits(props) {
    if (props.fractionDigits > MAX_SAFE_DIGITS) {
      return new Error("[CurrencyLabel]: Prop 'fractionDigits' exceeds " + MAX_SAFE_DIGITS + "." + "\nSee https://tech.skbkontur.ru/react-ui/#/CurrencyInput?id=why15");
    }

    var _ref = CurrencyHelper.destructString(String(props.value)) || {
      fraction: ''
    },
        fraction = _ref.fraction;

    if (fraction.length > props.fractionDigits) {
      return new Error("[CurrencyLabel]: Prop 'fractionDigits' less than fractional part of the 'value' property," + "'value' will not be cutted");
    }

    if (!Number.isInteger(props.fractionDigits)) {
      return new Error("[CurrencyLabel]: Prop 'fractionDigits' is not integer, fraction part of these property will not be used");
    }

    return null;
  }
};